import React, { useState } from 'react'
import { Button, TextField, Typography } from '@material-ui/core';
import { emailValidator, passwordValidator, passwordMatchValidator, errorCodeTranslator } from '../../api/utils/validator';
import { useHistory } from 'react-router';
import ConfirmDialog from './ConfirmDialog';
import { useCommProvider } from "../../api/CommProvider";
import { useTranslation } from "react-i18next";

export function Register() {
    const { t } = useTranslation("global")

    const history = useHistory();
    const { comm_signup } = useCommProvider();
    const [openDialog, setOpenDialog] = useState(false);
    /* Validation */
    const [email, setEmail] = useState({ value: "", error: "" });
    const [password, setPassword] = useState({ value: "", value2: "", error: "" });
    const [errorText, setErrorText] = useState("");


    /* Validation and register */
    function onRegisterPressed(e) {
        e.preventDefault();

        const emailError = emailValidator(email.value);
        const passwordError = passwordValidator(password.value);
        const passwordMatchError = passwordMatchValidator(password.value, password.value2);

        /* Clean error messages first */
        setEmail({ ...email, error: "" });
        setPassword({ ...password, error: "" });

        /* Check for errors */
        if (emailError || passwordError) {
            setEmail({ ...email, error: emailError });
            setPassword({ ...password, error: passwordError });
            return;
        }
        else if (passwordMatchError) {
            setPassword({ ...password, error: passwordMatchError });
            return;
        }

        /* Open confirm dialog */
        setOpenDialog(true);
    };

    /* Register */
    async function authRegister() {
        setOpenDialog(false)
        setErrorText("");
        try {
            await comm_signup(email.value, password.value);
            // history.push('/');
        }
        catch (e) {
            console.error(e)
            setErrorText(errorCodeTranslator(e));
        }
    }

    return (
        <>
            <form className="sig_SignIn_Form" noValidate onSubmit={onRegisterPressed}>
                <TextField
                    onChange={(e) => {
                        setEmail({ ...email, value: e.target.value });
                    }}
                    helperText={email.error}
                    FormHelperTextProps={{ error: true }}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="email"
                    label="Correo electrónico"
                    type="email"
                    id="email"
                    className="sig_SignIn_LoginInputFields"
                />
                <TextField
                    onChange={(e) => {
                        setPassword({ ...password, value: e.target.value });
                    }}
                    // helperText={password.error}
                    // FormHelperTextProps={{ error: true }}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="password"
                    label="Contraseña"
                    type="password"
                    id="password"
                    className="sig_SignIn_LoginInputFields"
                />
                <TextField
                    onChange={(e) => {
                        setPassword({ ...password, value2: e.target.value });
                    }}
                    helperText={password.error}
                    FormHelperTextProps={{ error: true }}
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="password"
                    label="Repetir contraseña"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    className="sig_SignIn_LoginInputFields"
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className="sig_SignIn_RegisterButton">
                    {t("sLogin.registerButton")}
                </Button>
                <br />
                {errorText && <Typography variant="body1" color="error">
                    {errorText}
                </Typography>
                }
            </form>
            <ConfirmDialog openDialog={openDialog} setOpenDialog={setOpenDialog} handleConfirm={authRegister} />
        </>
    )
}
